import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.jpg/)); }

const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreOvaloA/", true, /\.jpg/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreOvaloB/", true, /\.jpg/)); }
const Torre3 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreOvaloC/", true, /\.jpg/)); }
const Torre4 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreOvaloD/", true, /\.jpg/)); }

const Torre5 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreF/", true, /\.jpg/)); }
const Torre6 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreG/", true, /\.jpg/)); }
const Torre7 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreH/", true, /\.jpg/)); }
const Torre8 = () => { return ImportHelper.importAll(require.context("../assets/images/TorreI/", true, /\.jpg/)); }

//Amenidades
const BBQ = () => { return ImportHelper.importAll(require.context("../assets/images/BBQ/", true, /\.jpg/)); }
const Piscina = () => { return ImportHelper.importAll(require.context("../assets/images/Piscina/", true, /\.jpg/)); }
const Infantil = () => { return ImportHelper.importAll(require.context("../assets/images/ParqueInfantil/", true, /\.jpg/)); }
const Voley = () => { return ImportHelper.importAll(require.context("../assets/images/CanchaVolleyball/", true, /\.jpg/)); }

export const ContextLoader = 
{
    "General View": GeneralView,
    "Torre A Ovalada": Torre1,
    "Torre B Ovalada": Torre2,
    "Torre C Ovalada": Torre3,
    "Torre D Ovalada": Torre4,
    "Torre F Tira": Torre5,
    "Torre G Tira": Torre6,
    "Torre H Tira": Torre7,
    "Torre I Tira": Torre8,
    "Piscina": Piscina,
    "BBQ": BBQ,
    "Zona Infantil": Infantil,
    "Cancha Vóley Playa": Voley,
}
